<template>
  <!-- 路桥-项目工地班组选择显示 -->
  <el-tree :data="treeList" :props="{children: 'children', label: 'name'}" @node-click="clickTreeNode" node-key="id" default-expand-all :expand-on-click-node="false" style="height: 100%;overflow: auto">
    <template #default="{data}">
      <div class="node-info">
            <span>
              <span class="name-tag project" v-if="data.level === 1">项目</span>
              <span class="name-tag site" v-else-if="data.level === 2">工地</span>
              <span class="name-tag classmate" v-else-if="data.level === 3">班组</span>
              <span>{{data.name}}</span>
            </span>
        <slot :data="data"></slot>
      </div>
    </template>
  </el-tree>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";

export default {
  emits: ["selectOne"],
  props: {
    treeData: {default: () => []},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "PSC",
  components: {
  },
  data() {
    return {
      treeList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.treeData, () => this.init(), {deep: true});
  },
  methods: {
    init() {
      this.treeList = this.treeData;
      this.setLevel(this.treeList, 1);
    },
    setLevel(list, level) {
      for (let i = 0; i < list.length; i++) {
        list[i].level = level;
        if (list[i].children && list[i].children.length > 0) {
          this.setLevel(list[i].children, level + 1);
        }
      }
    },
    clickTreeNode(node, el) {
      // 选中某一个节点
      this.$emit("selectOne", node, el);
    }
  }
};
</script>

<style lang="scss" scoped>
.node-info{
  position: relative;
  .name-tag{
    margin-right: 5px;
    color: #FFF;
    padding: 0 5px;
    font-size: 12px;
    border-radius: 4px;
    &.project{
      background: var(--el-color-primary);
    }
    &.site{
      background: var(--el-color-warning);
    }
    &.classmate{
      background: var(--el-color-success);
    }
  }
}
</style>